// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__VLJFM","topbtn":"styles_topbtn__prb3Q","topbtnicon":"styles_topbtnicon__z71ZP","gototop":"styles_gototop__WKRVY"};